<h4 class="m-0">{{ 'SELECT_TENANT.DIALOG_TITLE' | translate }} {{ platformName }}</h4>
<h5>{{ 'SELECT_TENANT.DIALOG_SUBTITLE' | translate }}</h5>
<p class="mt-5">{{ 'SELECT_TENANT.DIALOG_INSTRUCTIONS' | translate }} <span class="text danger bold">*</span></p>

<mat-dialog-content>
  <vitamui-common-item-select
    [label]="'SELECT_TENANT.SELECT' | translate"
    [selectedLabel]="'SELECT_TENANT.SELECTED' | translate"
    (itemSelected)="selectedTenant = $event"
    [items]="tenants"
    appearance="outline"
  >
  </vitamui-common-item-select>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="w-100 btn primary" [disabled]="!selectedTenant" (click)="closeDialog()">
    {{ 'SELECT_TENANT.DIALOG_BUTTON_LABEL' | translate }} {{ platformName }}
  </button>
</mat-dialog-actions>
<p class="text normal mx-auto mt-4"><span class="text danger bold">*</span> {{ 'SELECT_TENANT.DIALOG_MESSAGE' | translate }}</p>
